import React from 'react';
import { Box, Typography, useTheme, Button } from '@mui/material';
import noDataImage from '../../assets/baseVersion/nodata_available.svg';

interface NoRowsOverlayProps {
    hasActiveAgent?: boolean;
    onAddRuleClick?: () => void;
    message?: string;
}

const NoRowsOverlay: React.FC<NoRowsOverlayProps> = ({ hasActiveAgent, onAddRuleClick, message }) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const isRuleManagement = window.location.pathname.includes('rule-management');
    const isCloudScan = window.location.pathname.includes('cloud/scans');
    const isOnPremScan = window.location.pathname.includes('on-premises/scans');
    const isAsset = window.location.pathname.includes("on-premises/assets")
    const isCloudResource = window.location.pathname.includes("cloud/cloud-resources")
    const isOnPremSecurityPosture = window.location.pathname.includes("on-premises/security-posture")
    const isDashboard = window.location.pathname.includes("dashboard")


    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                padding: 4,
                textAlign: 'center'
            }}
        >
            <Box
                component="img"
                src={noDataImage}
                alt="No Data"
                sx={{
                    width: isDashboard ? '40px' : '90px',
                    height: 'auto',
                    marginBottom: 2,
                    opacity: isDarkMode ? 0.6 : 0.8
                }}
            />
            <Typography
                variant="h6"
                sx={{
                    fontWeight: isDashboard ? 500 : 700,
                    color: theme.palette.text.primary,
                    fontSize: isDashboard ? '12px' : '18px',
                    mb: 0.5
                }}
            >
                {message || "There is no data available."}
            </Typography>
            <Typography
                variant="body2"
                sx={{
                    color: theme.palette.text.secondary,
                    fontSize: '14px',
                    mb: 2
                }}
            >
                {isRuleManagement && hasActiveAgent ? "Click the below button to add rule." : ""}
            </Typography>
            {isRuleManagement && hasActiveAgent && (
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={onAddRuleClick}
                    sx={{
                        textTransform: "none",
                        borderRadius: "8px",
                        fontWeight: 700,
                        px: 2.5,
                        py: 0.5,
                    }}
                >
                    Add Rule
                </Button>
            )}
        </Box>
    );
};

export default NoRowsOverlay;
